/* سند — سكربت الواجهة (بدون مكتبات) */
(function(){
  'use strict';
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}

  /* شريط الإعلان: تدوير الرسائل + إغلاق */
  function initAnn(root){
    if(root.__snReady) return; root.__snReady=true;
    var msgs=qsa('.sn-ann__msg',root); if(!msgs.length) return;
    try{ if(sessionStorage.getItem('snAnnClosed')==='1' && !window.Shopify.designMode){ root.classList.add('is-hidden'); return; } }catch(e){}
    var i=0;
    function show(n){ msgs[i].classList.remove('is-active'); i=(n+msgs.length)%msgs.length; msgs[i].classList.add('is-active'); }
    var next=qs('[data-sn-ann-next]',root), prev=qs('[data-sn-ann-prev]',root), close=qs('[data-sn-ann-close]',root);
    if(next) next.addEventListener('click',function(){show(i+1)});
    if(prev) prev.addEventListener('click',function(){show(i-1)});
    if(close) close.addEventListener('click',function(){ root.classList.add('is-hidden'); try{sessionStorage.setItem('snAnnClosed','1')}catch(e){} });
    if(msgs.length>1) setInterval(function(){show(i+1)},5000);
  }

  /* قائمة الجوال */
  function initMenu(){
    var menu=qs('[data-sn-menu]'); if(!menu || menu.__snReady) return; menu.__snReady=true;
    function open(){menu.classList.add('is-open');document.documentElement.style.overflow='hidden'}
    function close(){menu.classList.remove('is-open');document.documentElement.style.overflow=''}
    qsa('[data-sn-menu-open]').forEach(function(b){b.addEventListener('click',open)});
    qsa('[data-sn-menu-close]').forEach(function(b){b.addEventListener('click',close)});
    menu.addEventListener('click',function(e){ if(e.target===menu) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }

  /* معرض الصور */
  function initGallery(root){
    if(root.__snReady) return; root.__snReady=true;
    var imgs=qsa('.sn-gallery__main img',root), th=qsa('.sn-gallery__thumbs button',root);
    th.forEach(function(b,n){ b.addEventListener('click',function(){
      imgs.forEach(function(im,k){im.classList.toggle('is-active',k===n)});
      th.forEach(function(t,k){t.classList.toggle('is-active',k===n)});
    }); });
  }

  /* بطاقة العرض: اختيار الباقة */
  function initOffer(root){
    if(root.__snReady) return; root.__snReady=true;
    var labels=qsa('.sn-bundle',root);
    labels.forEach(function(l){
      var inp=qs('input',l); if(!inp) return;
      inp.addEventListener('change',function(){
        if(!inp.checked) return;
        labels.forEach(function(x){var xi=qs('input',x);x.classList.toggle('is-selected',!!(xi&&xi.checked))});
        qsa('[data-sn-price]',root).forEach(function(p){p.textContent=l.getAttribute('data-price')});
        qsa('form [name="id"]',root).forEach(function(h){h.value=inp.value});
        try{ var u=new URL(location.href); u.searchParams.set('variant',inp.value); history.replaceState(history.state,'',u.toString()); }catch(e){}
        qsa('.sn-bundle input[value="'+inp.value+'"]').forEach(function(o){ if(o!==inp && !o.checked){ o.checked=true; o.dispatchEvent(new Event('change',{bubbles:true})); } });
      });
    });
  }

  /* الشريط اللاصق: يظهر عندما لا تكون أي بطاقة طلب ظاهرة */
  function initSticky(){
    var bar=qs('[data-sn-sticky]'); if(!bar || bar.__snReady) return; bar.__snReady=true;
    var targets=qsa('.sn-offer'), visible=0;
    function update(){ bar.classList.toggle('is-visible', visible===0 && window.scrollY>360); }
    if('IntersectionObserver' in window && targets.length){
      var state=new Map();
      var io=new IntersectionObserver(function(es){ es.forEach(function(e){ state.set(e.target,e.isIntersecting); }); visible=0; state.forEach(function(v){ if(v) visible++; }); update(); },{threshold:0.08});
      targets.forEach(function(t){io.observe(t)});
    }
    window.addEventListener('scroll',update,{passive:true}); update();
  }

  /* السلايدر الأفقي (اتجاه عربي) */
  function initSliders(scope){
    qsa('[data-sn-slider]',scope).forEach(function(w){
      if(w.__snReady) return; w.__snReady=true;
      var s=qs('.sn-slider',w), p=qs('.sn-slider-btn--prev',w), n=qs('.sn-slider-btn--next',w);
      if(!s) return;
      function step(){ var c=s.firstElementChild; return c? c.getBoundingClientRect().width+20 : 300; }
      if(n) n.addEventListener('click',function(){ s.scrollBy({left:-step(),behavior:'smooth'}) });
      if(p) p.addEventListener('click',function(){ s.scrollBy({left:step(),behavior:'smooth'}) });
    });
  }

  /* الفيديو: تشغيل الصوت */
  function initVideos(scope){
    qsa('[data-sn-sound]',scope).forEach(function(b){
      if(b.__snReady) return; b.__snReady=true;
      b.addEventListener('click',function(){
        var v=b.closest('.sn-video__frame').querySelector('video'); if(!v) return;
        qsa('.sn-video__frame video').forEach(function(o){ if(o!==v){ o.muted=true; } });
        qsa('[data-sn-sound]').forEach(function(o){ if(o!==b){ var sp=o.querySelector('span'); if(sp) sp.textContent=o.getAttribute('data-on'); } });
        v.muted=!v.muted; if(!v.muted){ try{v.currentTime=0;v.play();}catch(e){} }
        var sp=b.querySelector('span'); if(sp) sp.textContent = v.muted ? b.getAttribute('data-on') : b.getAttribute('data-off');
      });
    });
  }

  function initAll(scope){
    qsa('[data-sn-ann]',scope).forEach(initAnn);
    qsa('[data-sn-gallery]',scope).forEach(initGallery);
    qsa('[data-sn-offer]',scope).forEach(initOffer);
    initSliders(scope); initVideos(scope);
  }
  function boot(){ initAll(document); initMenu(); initSticky(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
  document.addEventListener('shopify:section:load',function(e){ initAll(e.target); initMenu(); initSticky(); });
})();
